import React from 'react';
import { Link } from 'react-router-dom';
import CatalogImage from '../catalog/CatalogImage';

/**
 * Subcategory / type tile for category hub pages (Shopify-style collection card).
 */
export default function CollectionGroupCard({ to, image, title, countLabel, onNavigate }) {
  const inner = (
    <>
      <div className="collection-group-card__media">
        <CatalogImage src={image} alt={title} className="collection-group-card__img" sizes="(max-width: 768px) 50vw, 25vw" />
        <span className="collection-group-card__overlay">Shop</span>
      </div>
      <div className="collection-group-card__body">
        <h3 className="collection-group-card__title">{title}</h3>
        {countLabel ? <p className="collection-group-card__meta">{countLabel}</p> : null}
      </div>
    </>
  );

  if (to) {
    return (
      <Link to={to} className="collection-group-card" onClick={onNavigate}>
        {inner}
      </Link>
    );
  }

  return <div className="collection-group-card">{inner}</div>;
}
